var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "ob1-cards",
        {
          staticClass: "card-height bg-white shadow-none",
          attrs: { "with-composite-link": false },
          on: {
            "ob1-cards-click": function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c(
            "a",
            {
              attrs: {
                href: "#",
                "data-oevent-category": _vm.trackZone,
                "data-oevent-action": "bloc_" + _vm.index,
                "data-oevent-label": _vm.tagLabel(_vm.device.name),
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.handleClick.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "px-1 pt-2" }, [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column align-items-center" },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.device.brand))]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass:
                          "text-center mb-0 mx-1 fw-bold device-name-wrapper",
                      },
                      [_vm._v(_vm._s(_vm.device.name))]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "img-mobile" }, [
                  _c(
                    "div",
                    { staticClass: "mb-1 img-history-mobile-container" },
                    [
                      _vm.device.image
                        ? _c("ob1-simple-image", {
                            attrs: {
                              visual: _vm.device.image,
                              "css-classes": "device-size",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.device.dasAccessible
        ? _c("das-tooltip", {
            staticClass: "me-auto",
            attrs: {
              id: "tooltip-history-" + _vm.index,
              das: _vm.device.dasAccessible,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }